export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./axis";



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/index.js
// module id = Mx2h
// module chunks = 0